// import { GAME_NAMES } from 'pages/constants';
import { RegistrationFilters } from '../constants';

export type ContentPropsT = {
	handleFilterSubmit: (submittedFilters: RegistrationFilters) => void;
	onClose: () => void;
};

export const FORM_FIELD_KEYS = {
	DATE_RANGE: 'dateRange',
	TOURNAMENT_ID: 'tournamentID',
	GAME_NAME: 'gameName',
	TOURNAMENT_TYPE: 'tournamentType',
	PWF_INVITE_ID: 'pwfInviteId'
};

export const SUNSET_GAME_NAMES: string[] = [];

export const TOURNAMENT_TYPE_OPTIONS = [
	{
		label: 'PWF',
		id: 'pwf'
	}
];
